import styled from 'styled-components';
import { spacing, positioning } from 'ui/theme/utils';

export const CrossIcon = styled.i.attrs(({ position = 'relative', size = '18px' }) => ({
  position,
  size,
}))`
  display: inline-block;
  vertical-align: middle;
  transform: rotate(45deg);
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  cursor: pointer;
  transition: all 200ms;
  opacity: ${({ opacity = 0.7 }) => opacity};
  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}

  &:hover {
    opacity: ${({ opacityOnHover = 1 }) => opacityOnHover};
  }

  &:before,
  &:after {
    content: '';
    pointer-events: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: ${({ color = 'grey', theme }) => theme.colors[color] || color};
    border-radius: 2px;
  }
  &:before {
    width: ${({ size }) => size};
    height: 2px;
  }
  &:after {
    width: 2px;
    height: ${({ size }) => size};
  }
`;
